import React, { useEffect, useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { Table, Chip, fmt } from "./kit";

// BD raporu: Super Admin / Manager sozlesmesi olan kisinin ajanslari, aylik gelir, faal sayisi,
// orantili maas ve ilk 3 ay %17 BD primi.
const BdReport = () => {
  const simdi = new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" }).slice(0, 7);
  const [ay, setAy] = useState(simdi);
  const [limit, setLimit] = useState(550000);
  const [hedef, setHedef] = useState(20);
  const [d, setD] = useState(null);
  const [loading, setLoading] = useState(true);
  const [acik, setAcik] = useState({});

  useEffect(() => {
    setLoading(true);
    fetch(`${baseURL}contract/admin/bd?month=${ay}&limit=${limit}&target=${hedef}`, { headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "" } })
      .then((r) => r.json())
      .then((r) => setD(r?.status ? r : null))
      .catch(() => setD(null))
      .finally(() => setLoading(false));
  }, [ay, limit, hedef]);

  const usd = (n) => `${(Number(n) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 })} $`;
  const inp = { padding: "3px 6px", border: "1px solid #E5E7EB", borderRadius: 6, width: 110 };

  return (
    <>
      <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 12, flexWrap: "wrap", fontSize: 13 }}>
        <span>Ay:</span>
        <input type="month" value={ay} onChange={(e) => setAy(e.target.value)} style={inp} />
        <span style={{ marginLeft: 10 }}>Faal limiti (coin/ay):</span>
        <input type="number" value={limit} onChange={(e) => setLimit(Number(e.target.value) || 0)} style={inp} />
        <span style={{ marginLeft: 10 }}>Hedef (Super Admin):</span>
        <input type="number" value={hedef} onChange={(e) => setHedef(Number(e.target.value) || 1)} style={{ ...inp, width: 70 }} />
        <span style={{ color: "#6B7280", marginLeft: "auto" }}>Gelir: ajans yayıncılarına o ay gelen brüt hediye coin'i (maaş tablosu kaydı)</span>
      </div>
      <Table
        loading={loading}
        head={["Görevli", "Ajans / faal", "Maaş (orantılı)", "BD primi %17 (ilk 3 ay)", ""]}
        empty="Super Admin / Manager sözleşmesi olan (AYVO ID'li) kimse yok."
        rows={(d?.list || []).flatMap((p) => {
          const k = p.contractNo;
          const rows = [
            <tr key={k}>
              <td>
                <b>{p.name}</b>
                <div style={{ fontSize: 11, color: "#6B7280" }}>
                  {p.appName} · ID {p.ayvoId} · Sözleşme {p.contractNo} {p.contractStatus !== "signed" ? "(imzalanmadı)" : ""}
                </div>
              </td>
              <td>
                {p.ajansSay} ajans ·{" "}
                <Chip kind={p.faalSay >= p.hedef ? "ok" : p.faalSay > 0 ? "wait" : "bad"}>
                  {p.faalSay}/{p.hedef} faal
                </Chip>
              </td>
              <td>
                <b>{fmt(p.odenecekMaasTl)} TL</b>
                <div style={{ fontSize: 11, color: "#6B7280" }}>
                  {fmt(p.maasTl)} TL × %{Math.round(p.oran * 100)}
                </div>
              </td>
              <td>
                <b>{usd(p.primUsd)}</b>
              </td>
              <td>
                <button className="btn btn-outline-secondary btn-sm" onClick={() => setAcik({ ...acik, [k]: !acik[k] })}>
                  {acik[k] ? "Gizle" : "Ajanslar"}
                </button>
              </td>
            </tr>,
          ];
          if (acik[k])
            rows.push(
              <tr key={k + "d"}>
                <td colSpan={5} style={{ background: "#F9FAFB" }}>
                  {p.ajanslar.length === 0 ? (
                    <div style={{ fontSize: 13, color: "#6B7280" }}>Bu kişiye bağlı ajans yok (ajansı kendisi açmalı ya da BD olarak atanmalı).</div>
                  ) : (
                    <table className="table table-sm" style={{ margin: 0 }}>
                      <thead>
                        <tr>
                          <th>Ajans</th>
                          <th>Bu ay gelir (coin)</th>
                          <th>Yayıncı</th>
                          <th>Ajans payı</th>
                          <th>Kaçıncı ay</th>
                          <th>Durum</th>
                          <th>Prim</th>
                        </tr>
                      </thead>
                      <tbody>
                        {p.ajanslar.map((a) => (
                          <tr key={a._id}>
                            <td>
                              {a.name} <span style={{ fontSize: 11, color: "#6B7280" }}>{a.code}</span>
                            </td>
                            <td>
                              {fmt(a.coins)}
                              <div style={{ height: 4, background: "#E5E7EB", borderRadius: 2, marginTop: 3, width: 120 }}>
                                <div style={{ height: 4, borderRadius: 2, width: `${Math.min(100, (a.coins / (d?.limit || 1)) * 100)}%`, background: a.faal ? "#16A34A" : "#F59E0B" }} />
                              </div>
                            </td>
                            <td>{a.hosts}</td>
                            <td>{usd(a.ajansUsd)}</td>
                            <td>{a.kacinciAy > 0 ? `${a.kacinciAy}. ay` : "-"}</td>
                            <td>{a.faal ? <Chip>Faal</Chip> : <Chip kind="bad">Limit altı</Chip>}</td>
                            <td>{a.primUsd ? usd(a.primUsd) : a.ilk3 ? "-" : "3 ay doldu"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </td>
              </tr>
            );
          return rows;
        })}
      />
      <div style={{ fontSize: 12, color: "#6B7280", marginTop: -6 }}>
        Kişiye bağlı ajanslar: kendi açtığı (Yönetim Paneli'nden) ya da BD olarak atandığı ajanslar. Maaş = sözleşmedeki TL maaş × (faal ajans / hedef). Hedef: Super Admin 20, Admin 10. Prim = faal ajansın o ayki ajans payının %17'si, ajansın ilk 3 ayında.
      </div>
    </>
  );
};

export default BdReport;
